module.exports = __webpack_public_path__ + "img/ad_placeholder@3x.5a1abe5f.png";